<template>
  <form>
    <FormElement name="model" label="Model" :vertical="false">
      <select slot="input" @input="onModelChange" :value="value">
        <option
          v-for="m in ModelInfo.filter(m => m.include).sort((a, b) =>
            a.pretty.localeCompare(b.pretty)
          )"
          :value="m.internal"
          :key="m.internal"
          >{{ m.pretty }}</option
        >
      </select>
      <transition name="fade">
        <Tooltip v-if="value === 'wikiart'" :key="value"
          >This model has been trained on 100,000+ paintings at a resolution of
          32x32 pixels. The paintings span many different artists, styles,
          colors, shapes, etc., across different time periods.</Tooltip
        >
        <Tooltip v-else-if="value === 'wikiart_portraits'" :key="value"
          >This model has been trained on 10,000+ portrait paintings at a
          resolution of 32x32 pixels. The paintings span many different artists,
          styles and colors across different time periods.</Tooltip
        >
        <Tooltip v-else-if="value === 'celeb_hq'" :key="value"
          >This model has been trained on 200,000+ images of celebrity faces at
          a resolution of 64x64 pixels.</Tooltip
        >
        <Tooltip v-else-if="value === 'celeb128'" :key="value"
          >This model has been trained on 200,000+ images of celebrity faces at
          a resolution of 128x128 pixels. The model did not succeed entirely in approximating the training data due to the high resolution compared to the model responsible for <i>Celebrity Faces</i>, but the results are interesting nonetheless.</Tooltip
        >
        <Tooltip v-else-if="value === 'celeb_hq_new'" :key="value"
          >This model has been trained on 200,000+ images of celebrity faces at
          a resolution of 64x64 pixels. The network is somewhat larger than the
          model responsible for <i>Celebrity Faces</i>.</Tooltip
        >
        <Tooltip v-else-if="value === 'celeb_cppn'" :key="value"
          >This model has been trained on 200,000+ images of celebrity faces at
          a resolution of 32x32 pixels. The models was constructed with a bias
          towards pronounced, interesting visual properties over photo-realistic
          results.</Tooltip
        >
        <Tooltip v-else-if="value === 'flowers'" :key="value"
          >This model has been trained on 3000+ images of various flowers at a
          resolution of 32x32 pixels.</Tooltip
        >
        <Tooltip v-else-if="value === 'cifar10'" :key="value"
          >This model has been trained on 60,000 32x32 images of various
          objects and animals, including cars, frogs, airplanes, horses, etc. The model
          failed to properly capture the visual properties of these complex
          classes, but the generated colors and various shapes are still representative of
          the training data.</Tooltip
        >
        <Tooltip v-else-if="value === 'cifar10_cars'" :key="value"
          >This model has been trained on 5000+ images of cars at a resolution
          of 32x32 pixels.</Tooltip
        >
        <Tooltip v-else-if="value === 'mnist'" :key="value"
          >This model has been trained on 60,000 images of numbers in the range
          1--9 at a resolution of 28x28 pixels.</Tooltip
        >
      </transition>
    </FormElement>
  </form>
</template>

<script>
import Tooltip from "./Tooltip.vue"
import FormElement from "./FormElement.vue"

import { ModelInfo } from "../util.js"
export default {
  name: "ModelForm",
  components: {
    FormElement,
    Tooltip
  },
  props: ["value"],
  data() {
    return {
      ModelInfo
    }
  },
  methods: {
    formSubmit(e) {
      e.preventDefault()
    },
    onModelChange(e) {
      e.preventDefault()
      this.$ga.event({
        eventCategory: "model",
        eventAction: "change"
      })
      this.$emit("update:value", e.target.value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

form {
  background-color: $color-dark-lighter;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 3px 3px 3px 3px;
  border: 2px solid #ededed;
  margin-bottom: 20px;
  margin-left: 10px;
  margin-right: 10px;
  position: relative; /* Allows tooltip to overlap other elements */
  z-index: 1;
}

label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-transform: uppercase;
}

select {
  background-color: $color-dark;
  color: white;
  width: 100%;
  flex-grow: 1;
  margin-right: 10px;
}

.label__value {
  font-weight: normal;
  font-style: oblique;
  margin-left: 5px;
}

.fade-enter-active {
  transition: all 0.5s ease-in;
}

.fade-leave-active {
  display: none;
}

.fade-enter,
.fade-leave-to {
  transform: scale(1.5);
  opacity: 1;
}

@media (max-width: 767px) {
  form {
    flex-grow: 1;
    flex-direction: column;
    margin-bottom: 20px;
  }

  select {
    width: 100%;
  }
}
</style>
